import React, { useCallback, useState } from "react";

import Popover from "antd/es/popover";
import { useIntl } from "react-intl";

import { Button, LargeTextField } from "@mapmycustomers/ui";

import useAnalytics from "@app/util/contexts/useAnalytics";

import messages from "./messages";
import styles from "./ReportPopover.module.scss";

interface ReportPopoverProps {
  children: React.ReactNode;
  onSubmit: (comment: string) => void;
}

const ReportPopover = ({ children, onSubmit }: ReportPopoverProps) => {
  const analytics = useAnalytics();
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState("");

  const handleSubmit = useCallback(() => {
    onSubmit(comment.trim());
    setOpen(false);
    setComment("");
  }, [comment, onSubmit]);

  const handleCancel = useCallback(() => {
    analytics.cancelled(["Report"]);
    setOpen(false);
    setComment("");
  }, [analytics]);

  return (
    <Popover
      content={
        <div className={styles.overlay}>
          <LargeTextField
            autoFocus
            className={styles.textarea}
            label={intl.formatMessage(messages.describeIssue)}
            onChange={setComment}
            placeholder={intl.formatMessage(messages.describeIssue)}
            value={comment}
          />
          <div className={styles.actions}>
            <Button onClick={handleCancel} size="small" type="default">
              {intl.formatMessage(messages.cancel)}
            </Button>
            <Button
              disabled={!comment.trim().length}
              onClick={handleSubmit}
              size="small"
              type="primary"
            >
              {intl.formatMessage(messages.report)}
            </Button>
          </div>
        </div>
      }
      destroyTooltipOnHide
      onOpenChange={setOpen}
      open={open}
      placement="top"
      trigger="click"
    >
      {children}
    </Popover>
  );
};

export default ReportPopover;
